
<div class="dashboard-tx flex flex-col sticky top-[90px] z-[2000] -translate-x-[15px] -translate-y-[24px] pt-3 pb-2 pl-[77px]  bg-white"
    style="box-shadow:0 4px 2px -2px rgba(0, 0, 0, 0.2);width:calc(100% + 30px)">
    <p class="text-2xl font-medium mb-2.5 text-[#003366]">BÁO CÁO THỐNG KÊ UCOD</p>
    <div class=" rounded-md mb-2 flex flex-row gap-3 dash">
        <div class=" flex items-center gap-3  relative">
            <mat-form-field class="small-form-field dash1" appearance="outline">
                <mat-label>Ngày bắt đầu</mat-label>
                <input matInput [matDatepicker]="startPicker" placeholder="Chọn ngày bắt đầu"
                    (dateChange)="startDateChanged($event)">
                <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                <mat-datepicker #startPicker></mat-datepicker>
            </mat-form-field>
            đến
            <mat-form-field class="small-form-field dash2" appearance="outline">
                <mat-label>Ngày kết thúc</mat-label>
                <input matInput [matDatepicker]="endPicker" placeholder="Chọn ngày kết thúc"
                    (dateChange)="endDateChanged($event)">
                <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                <mat-datepicker #endPicker></mat-datepicker>
            </mat-form-field>
        </div>
        <button [disabled]="loadding" mat-raised-button (click)="reGenerate()" class="my-1  hover:opacity-95 button1 " color="primary"><span class="text1">Thống kê</span>

            <svg class="icon1" xmlns="http://www.w3.org/2000/svg" height="20" width="22.5" viewBox="0 0 576 512"><path fill="#ffffff" d="M304 240l0-223.4c0-9 7-16.6 16-16.6C443.7 0 544 100.3 544 224c0 9-7.6 16-16.6 16L304 240zM32 272C32 150.7 122.1 50.3 239 34.3c9.2-1.3 17 6.1 17 15.4L256 288 412.5 444.5c6.7 6.7 6.2 17.7-1.5 23.1C371.8 495.6 323.8 512 272 512C139.5 512 32 404.6 32 272zm526.4 16c9.3 0 16.6 7.8 15.4 17c-7.7 55.9-34.6 105.6-73.9 142.3c-6 5.6-15.4 5.2-21.2-.7L320 288l238.4 0z"/></svg>
            
           
            <mat-spinner [diameter]="20" *ngIf="loadding"></mat-spinner>
        </button>
    </div>
</div>
<div class="px-[60px] mt-[20px] mb-10 dashsing">
    <div class="rounded-md border-c py-3 px-4 bg-white">
        <div class="flex  gap-2.5 flex-col w-full">
            <p class="font-semibold  text-black text-[17px] mb-1">Độ chính xác</p>
            <div class="flex flex-row gap-3 items-end">
                <span class="text-[25px] text-black leading-7 line font-semibold">{{textBoxData?.ratio}}</span> <span
                    class="text-gray-500 text-sm">Chiếm {{textBoxData?.percent}}</span>
            </div>
            <p class="mb-0">Đến ngày {{formatDateCus(textBoxData?.date_now)}}</p>
        </div>
    </div>
    <div class="p-3 mt-4 max-h-[700px] overflow-auto rounded-md border-c grid-chart bg-white">
        <div class="sticky top-[-16px] bg-white py-3">
            <div class="ml-2 bg-white  mb-2 text-[18px] font-bold " style="width:calc(100% - 25px)">
                Thống kê tử vong theo mã bệnh<br>
                <span class="text-black font-normal mt-1 block text-[14px]">Tất cả các trường hợp tử vong đi sâu vào mã
                    bệnh
                    , Cả hai giới tính , mọi chủng tộc , mọi dân tộc</span>
            </div>
        </div>
        
        <table class="mb-2" *ngIf="tableData; else noData">
            <thead class="bg-[#efefef] h-[42px] sticky top-[60px]">
                <tr>
                    <th class="!font-semibold text-center" *ngFor="let ageGroup of tableData[0]">{{ ageGroup.name }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let row of tableData.slice(1); let i = index">
                    <tr class="h-[35px]" [ngClass]="{'bg-white': i % 2 !== 0, 'bg-[#efefef]': i % 2 === 0}">
                        <td class="text-center" *ngFor="let entry of row; let idx = index">
                            <div class="w-full" [ngClass]="{'font-medium': idx===0}">
                                <div>
                                    <span class="mt-1">{{entry.value}}</span>
                                </div>
                            </div>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
        
        <ng-template #noData>
            <div class="flex justify-center items-center h-[300px]">
                <p class="text-[#003 ]">{{tableData_error}}</p>
            </div>
        </ng-template>


      

    </div>
    <div class="rounded-md border-c p-3 bg-white mt-4">
        
        <div id="ucod_line"></div>
    </div>

    <div class="rounded-md border-c p-3 bg-white mt-4 items-center">
        <div #heatMap></div>
    </div>
</div>